import React, { useEffect } from "react";
import { Card, Table, Alert, Spinner, ProgressBar, Container } from "react-bootstrap";
import { useSuperState } from "helpers/hooks";
import { useApp } from "common/context";

const Instances = props => {

    const [state, setState] = useSuperState({
        error: null,
        loading: true,
        instances: null,
        appstream_fleet_name: null
    });

    const { api } = useApp();
    const { error, loading, instances, appstream_fleet_name } = state;

    const refreshInstances = async () => {

        await api.get("/api/appstream/instances/metrics", { appstream_fleet_name }).then(({ instances }) => {
            setState({
                instances
            });
        }).catch(e => {
            setState({ error: e?.err || e.toString() });
        });

    };

    useEffect(() => {

        let interval;

        (async () => {

            await refreshInstances();

            setState({ loading: false });

            interval = setInterval(refreshInstances, 10000);

        })();

        return () => {

            clearInterval(interval);

        };

    }, [appstream_fleet_name]);

    return (
        <Container>
            <h1>Instances</h1>
            <hr/>
            {error && <Alert variant="warning">{error}</Alert>}
            {loading &&
                <div className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            }
            {!loading && !error &&
                <Card>
                    <Card.Body>
                        <Table className="m-0" borderless striped>
                            <thead>
                                <tr>
                                    <th>Instance ID</th>
                                    <th>Fleet</th>
                                    <th>Active Sessions</th>
                                    <th>CPU Usage</th>
                                    <th>Memory Usage</th>
                                </tr>
                            </thead>
                            <tbody>
                                {instances && instances.map(instance => {

                                const { appstream_instance_id, appstream_fleet_name, cpu_usage, memory_usage, active_sessions } = instance;

                                const variant = value => {
                                    if (value > 70)
                                        return 'danger';
                                    if (value > 40)
                                        return 'warning';
                                    return '';
                                };

                                return (
                                    <>
                                        <tr>
                                            <td className="align-middle">
                                                {appstream_instance_id}
                                            </td>
                                            <td className="align-middle">
                                                {appstream_fleet_name}
                                            </td>

                                            <td className="align-middle">
                                                {active_sessions}
                                            </td>
                                            <td className="align-middle">
                                                <div className="d-flex">
                                                    <div style={{ flexShrink: 0 }} className="me-1">{Math.round(cpu_usage)}%</div>
                                                    <div style={{ flexGrow: 1 }}>
                                                        <ProgressBar variant={variant(cpu_usage)} now={cpu_usage} style={{ height: 25, border: '1px solid #ddd' }} />
                                                    </div>
                                                </div>

                                            </td>
                                            <td className="align-middle">
                                                <div className="d-flex">
                                                    <div style={{ flexShrink: 0 }} className="me-1">{Math.round(memory_usage)}%</div>
                                                    <div style={{ flexGrow: 1 }}>
                                                        <ProgressBar variant={variant(memory_usage)} now={memory_usage} style={{ height: 25, border: '1px solid #ddd' }} />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </>
                                );
                            })}
                                {!instances?.length && <tr>
                                    <td colSpan={5} className="text-center">No active instances</td>
                                </tr>}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            }
        </Container>
    );
};

export default Instances;
